/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { GiThink } from 'react-icons/gi';
import { IoWarningOutline } from 'react-icons/io5';
import emailList from '../../constants/emailList';

const Notification = ({
  showNotification,
  hideNotification,
  notificationType,
  message
}) => {
  const handleContactClick = () => {
    window.location.href = `mailto:${emailList.support}?subject=Report A Bug`;
  };

  const messageClass = () => {
    switch (notificationType) {
      case 'success':
        return 'success-message';
      case 'lostConnection':
        return 'error-message lost-connection';
      case 'error':
        return 'error-message';
      case 'unauthorized':
        return 'unauthorized-message';
      default:
        return '';
    }
  };

  return (
    <>
      {showNotification && (
        <div className="notification-backdrop" onClick={hideNotification}>
          <div className="notification" onClick={(e) => e.stopPropagation()}>
            <div className={`center notification-body ${notificationType}`}>
              <div className="notification-text-container">
                {notificationType === 'error' ? <GiThink size="3.3em" /> : null}
                {notificationType === 'lostConnection' ? (
                  <IoWarningOutline size="3.3em" />
                ) : null}
                <div className={messageClass()}>{message}</div>
              </div>
              <div className="notification-buttons">
                {['error', 'lostConnection'].includes(notificationType) ? (
                  <button
                    className="notification-contact-us"
                    onClick={handleContactClick}
                    type="button"
                  >
                    Contact Us
                  </button>
                ) : null}
                <button
                  onClick={() => hideNotification()}
                  type="button"
                  className={`${
                    notificationType === 'success'
                      ? 'success-dismiss-button'
                      : 'error-dismiss-button'
                  }`}
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Notification.propTypes = {
  showNotification: PropTypes.bool,
  notificationType: PropTypes.string,
  message: PropTypes.string
};

export default Notification;
